import { Component, Input, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController, PopoverController, ToastController  } from 'ionic-angular';
import {
    PlatformService, LoggingService, TokenService,
    LocalStorageService, NotificationsService, AccountService, User
} from '@varsity/services';
import { GLOBAL_CONSTANTS } from '@varsity/commons';
import { BaseComponent, DisplayMessageComponent } from '@varsity/components';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the SideMenuComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'side-menu',
    templateUrl: 'side-menu.html'
})
export class SideMenuComponent extends BaseComponent {
    @ViewChild(Nav) nav: Nav;
    rootPage: any = 'home';
    pages: Array<{ title: string, icon: string, hasBadge?: boolean, getBadgeCounter?: () => string, isVisible: () => boolean, action: () => void }>;
    currentAppVersion: string;
    user: User | null;
    displayName: string;
    site: string;
    email: string;

    constructor(
        protected platform: Platform,
        protected menuCtrl: MenuController,
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected popoverCtrl: PopoverController,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "SideMenuComponent"
        );
        this.loggingService.log('Hello SideMenuComponent Component');

        this.site = this.platformService.getSite()
        //if (this.site = "Sideline Tix") {
            this.email = "support@sidelinetix.com"
        ///} else {
        //    this.email = "support@varsitytix.com"
        //}

        this.platformService.openPage$
            .takeUntil(this.componentDestroyed$)
            .subscribe((data) => {
                this.loggingService.debug("Opening page==", data);
                this.nav.push(data.page, JSON.parse(data.params));
            });

        this.pages = [
            {
                title: 'Home', icon: 'home',
                action: () => {
                    this.openPage('home');
                },
                isVisible: () => {
                    return true;
                }
            },
            {
                title: 'My Tickets', icon: 'pricetags',
                action: () => {
                    this.openPage('account-events');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? true : false;
                }
            },
            {
                title: 'My Receipts', icon: 'paper',
                action: () => {
                    this.openPage('account-receipts');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? true : false;
                }
            },
            {
                title: 'My Account', icon: 'person',
                action: () => {
                    this.openPage('account');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? true : false;
                }
            },
            {
                title: 'Notifications', icon: 'notifications', hasBadge: true,
                getBadgeCounter: () => {
                    let badgeString = "";

                    if (this.notificationsService.notificationCounter > 0) {
                        badgeString = (this.notificationsService.notificationCounter > 9) ? "9+" : this.notificationsService.notificationCounter.toString();
                    }
                   
                    //this.accountService.getUserNotifications().subscribe((value) => {
                    //    if (value && value.length > 0) {
                    //        badgeString = (value.length > 9) ? "9+" : value.length.toString();
                    //    } 
                    //});
                    
                    //badgeString = "9+";


                    // TODO if more than 9 notifications display '9+'

                    // otherwise return number

                    return badgeString;
                },
                action: () => {
                    this.openPage('account-notifications');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? true : false;
                }
            },
            {
                title: 'Cart', icon: 'cart',
                action: () => {
                    this.openPage('cart');
                },
                isVisible: () => {
                    return super.getCart() != null ? true : false;
                }
            },
            {
                title: 'Logout', icon: 'power',
                action: () => {
                    this.platformService.notificationToken$
                        .take(1)
                        .subscribe((value) => {
                            if (super.getCart() && super.getCart().tickets.length > 0) {
                                super.showPopover(DisplayMessageComponent, {
                                    icon: "information-circle",
                                    header: "Confirm logout",
                                    content: ["Your cart still contains items.", "By proceeding the cart will be lost and you will be redirected to the home screen.", "Do you want logout?"],
                                    buttons: [{ tag: 'no', text: 'No' }, { tag: 'yes', text: 'Yes' }],
                                    footer: null
                                }, 'display-message', (data) => {
                                    if (data.button && data.button.tag == 'yes') {
                                        this.accountService.TRLogOut(value)
                                            .takeUntil(this.componentDestroyed$)
                                            .subscribe(() => {
                                                this.loggingService.debug('logged out');
                                                this.localStorageService.clear();
                                                this.notificationsService.notifyUserLoginChanged(null);
                                                this.notificationsService.notifyConfirmationChanged(null);
                                                this.notificationsService.notifyAvailableNotificationsChanged(0);
                                                // we just cleared the local storage, so we can generate a new token
                                                this.tokenService.ensureValidToken();
                                            },
                                                (error) => {
                                                    this.handleError(error);
                                                });
                                    }
                                });
                            } else {
                                this.accountService.TRLogOut(value)
                                    .takeUntil(this.componentDestroyed$)
                                    .subscribe(() => {
                                        this.loggingService.debug('logged out');
                                        this.localStorageService.clear();
                                        this.notificationsService.notifyUserLoginChanged(null);
                                        this.notificationsService.notifyConfirmationChanged(null);
                                        this.notificationsService.notifyAvailableNotificationsChanged(0);
                                        // we just cleared the local storage, so we can generate a new token
                                        this.tokenService.ensureValidToken();

                                    },
                                        (error) => {
                                            this.handleError(error);
                                        });
                            }
                        });
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? true : false;
                }
            },            
            {
                title: 'Login', icon: 'person',
                action: () => {
                    this.openLoginPopover('login');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? false : true;
                }
            },
            
            {
                title: 'Forgot password', icon: 'unlock',
                action: () => {
                    this.openLoginPopover('recover-password');
                },
                isVisible: () => {
                    return this.notificationsService.loggedInUser ? false : true;
                }
            },
            {
                title: 'Help / FAQ', icon: 'help-circle',
                action: () => {
                    super.showPopover(DisplayMessageComponent, {
                        icon: "help-circle",
                        header: "Help",
                        content: [`If you need assistance with your ticket purchase, please contact us at ${this.email}.`],
                        buttons: [{ tag: 'faq', text: 'Go to FAQ' }, { tag: 'close', text: 'Close' }],
                        footer: null,
                    }, "display-message", (d) => {
                        if (d && d.button && d.button.tag == "faq") {
                            this.loggingService.debug("Redirecting to FAQ page");
                            this.openPage('faq');
                        }
                    })
                },
                isVisible: () => {
                    return true;
                }
            },


        ];

        this.user = this.notificationsService.loggedInUser;
        if (this.user) {
            this.displayName = super.getUserDisplayName(this.user);
        }

        this.notificationsService.loggedInUser$
            .takeUntil(this.componentDestroyed$)
            .subscribe((user) => {
                if (user && !user.AutoLoggedIn && window.location.href.indexOf("/#/home") > -1) {
                    setTimeout(() => {
                        if (window.location.href.indexOf("/#/home") > -1) {
                            this.openPage("account");
                        }
                    }, 1000);
                } else {
                    if (!user && this.user) {
                        // logged out user
                        this.openPage('home');
                        this.showNotification('User logged out', undefined, undefined, "notification");
                        this.displayName = null;
                    }

                    if (!this.user && user && !user.AutoLoggedIn) {
                        this.showNotification('User logged in', undefined, undefined, "success");
                        this.displayName = super.getUserDisplayName(user);
                    }
                }

                this.user = user;
            });

        this.platformService.notificationClicked$
            .takeUntil(this.componentDestroyed$)
            .subscribe(info => {
                this.accountService.updateNotification(info.notificationId, "Update");
            });


        this.currentAppVersion = GLOBAL_CONSTANTS.appVersion + "." + GLOBAL_CONSTANTS.appBuild;
        if (GLOBAL_CONSTANTS.appIteration) {
            this.currentAppVersion += "-" + GLOBAL_CONSTANTS.appIteration;
        }
    }

    openPage(segment: string) {
        // Reset the content nav to have just this page
        // we wouldn't want the back button to show in this scenario
        this.nav.setRoot(segment);
    }
}



// WEBPACK FOOTER //
// ./src/components/side-menu/side-menu.ts